<template>

    <Head>
        <title>{{ title }} | {{ description }}</title>
    </Head>
    <div v-if="status === 404">
        <div class="container">s
            <div>
                <div>
                    <h3 class=""> <b> &iexcl;Hola! </b> Una disculpa pero la página solicitada no se encuentra
                        disponible <br> Puedes regresar a nuestra <Link href="/"> página principal </Link> o buscar en nuestro
                        sitio. </h3>
                </div>
            </div>
        </div>
    </div>
    <div v-else>
        <h1>{{ title }}</h1>
        <div>{{ description }}</div>
    </div>
</template>

<script>
import { Link } from '@inertiajs/inertia-vue3'
export default {
    components: { Link },
    props: {
        status: Number,
    },
    computed: {
        title() {
            return {
                503: '503: Service Unavailable',
                500: '500: Server Error',
                404: '404: Página no encontrada',
                403: '403: Prohibido',
            }[this.status]
        },
        description() {
            return {
                503: 'Lo sentimos, estamos haciendo un poco de mantenimiento. Por favor, revise luego.',
                500: 'Vaya, algo salió mal en nuestros servidores.',
                404: 'Lo sentimos, no se pudo encontrar la página que está buscando.',
                403: 'Lo sentimos, tiene prohibido acceder a esta página.',
            }[this.status]
        },
    },
}
</script>
